import { useCallback, useMemo } from 'react'
import { useSceneMarker } from '@editor/hooks'
import { ThreeEvent } from '@react-three/fiber'

const OpeningSceneMarker = ({
  opening,
  isSelected,
  onSelect,
}: {
  opening: Opening
  isSelected: boolean
  onSelect: (openingGuid: string) => void
}): null => {
  const center = useMemo(() => {
    const [p1, , p3] = opening.shape.points
    return {
      x: (p1.x + p3.x) / 2,
      y: (p1.y + p3.y) / 2,
      z: (p1.z + p3.z) / 2,
    }
  }, [opening.shape.points])

  const handleClick = useCallback(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    (event: ThreeEvent<MouseEvent>) => {
      onSelect(opening.guid)
    },
    [onSelect, opening.guid],
  )

  useSceneMarker({
    marker: center,
    size: 0.05,
    enabled: true,
    color: isSelected ? 'orange' : '#9e9e9e',
    disableDepthTest: true,
    onClick: handleClick,
    animated: false,
  })

  return null
}

export default OpeningSceneMarker
